"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone, Calendar } from "lucide-react";
const servicesLinks = [{
  title: "דף הבית",
  url: "/"
}, {
  title: "פתרון מיידי",
  url: "/ImmediateSolutionPage"
}, {
  title: "מטפל סיעודי",
  url: "/CaregiverServicePagesPage"
}, {
  title: "מטפל סיעודי ישראלי",
  url: "/NursingCareNowPage"
}];
const locations1 = [{
  title: "תל אביב",
  url: "/NursingCaregiverInTelAvivWithinFiveHoursPage"
}, {
  title: "רמת גן",
  url: "/NursingCaregiverInRamatGanWithinHoursPage"
}, {
  title: "גבעתיים",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "בני ברק",
  url: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  title: "חולון",
  url: "/NursingCaregiverInRishonLeZionWithinFiveHoursPage"
}, {
  title: "בת ים",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "ראשון לציון",
  url: "/NursingCaregiverInRishonLeZionWithinFiveHoursPage"
}, {
  title: "פתח תקווה",
  url: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  title: "הרצליה",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "רמת השרון",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}];
const locations2 = [{
  title: "חיפה",
  url: "/NursingCareProviderInHaifaWithinFiveHoursPage"
}, {
  title: "ירושלים",
  url: "/SeoPagesForNursingCareProviderInJerusalemHaifaPetahTikvaAndNetanyaPage"
}, {
  title: "מודיעין",
  url: "/NursingCaregiverInModiinWithinFiveHoursPage"
}, {
  title: "נתניה",
  url: "/SeoPagesForNursingCareProviderInJerusalemHaifaPetahTikvaAndNetanyaPage"
}, {
  title: "רעננה",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "כפר סבא",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "אשדוד",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "באר שבע",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "רחובות",
  url: "/NursingCaregiverInCityImmediateSolutionWithinFiveHoursPage"
}, {
  title: "צפו בכל האזורים",
  url: "/ServicesCitiesArticlesPage"
}];
export default function FinalCta() {
  return <section data-section-id="260389" id="צרו-קשר-עכשיו-מטפל-סיעודי-בתל-אביב" className="bg-primary text-primary-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 text-primary-foreground">
            בחרו בפתרון המיידי שלנו בתל אביב
          </h2>
          <p className="font-default text-lg md:text-xl text-primary-foreground/80 mb-8">
            צרו קשר עכשיו לקבלת מטפל סיעודי מקצועי ומסור המותאם לצרכים שלכם, עם זמינות מיידית בפריסה ארצית.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="rounded-lg bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-md">
              <Link to="tel:0500000000">
                <Phone className="w-5 h-5" />
                התקשרו עכשיו
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-lg bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary shadow-md">
              <Link to="https://wa.me/972500000000">
                <SafeHydrate><Calendar className="w-5 h-5" /></SafeHydrate>
                שלחו הודעת WhatsApp
              </Link>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 pt-12 border-t border-primary-foreground/20">
          <div className="flex flex-col gap-4">
            {servicesLinks.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-primary-foreground/70 hover:text-secondary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          <div className="flex flex-col gap-4">
            {locations1.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-primary-foreground/70 hover:text-secondary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          <div className="flex flex-col gap-4">
            {locations2.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-primary-foreground/70 hover:text-secondary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-default text-sm font-semibold text-primary-foreground mb-2">הרשמה לעדכונים</h3>
            <div className="relative border-b border-primary-foreground/50 pb-2 flex items-center">
              <input type="email" placeholder="האימייל שלך" className="font-default bg-transparent border-none outline-none w-full text-sm text-primary-foreground placeholder:text-primary-foreground/50" />
              <Button variant="ghost" size="icon" className="text-primary-foreground/70 hover:text-secondary transition-colors ml-2 h-auto w-auto p-0">
                <ArrowRight className="w-4 h-4" />
                <span className="sr-only">הירשם</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}